// extracted by mini-css-extract-plugin
export default {"invalidDataError":"Userprofile_invalidDataError__RQjoj"};